export enum GameVariantCategory {
  MultiplayerSlayer = 6,
  MultiplayerAttrition = 7,
  MultiplayerElimination = 8,
  MultiplayerFiesta = 9,
  MultiplayerStrongholds = 11,
  MultiplayerKingOfTheHill = 12,
  MultiplayerTotalControl = 14,
  MultiplayerCtf = 15,
  MultiplayerExtraction = 17,
  MultiplayerOddball = 18,
  MultiplayerStockpile = 19,
  MultiplayerInfection = 22,
  MultiplayerVIP = 23,
  MultiplayerEscalation = 24,
  MultiplayerGrifball = 25,
  MultiplayerLandGrab = 39,
  MultiplayerMinigame = 41,
  MultiplayerFirefight = 42,
}
